<template lang="pug">
UiFormGroup(
  :label="label"
  :vuelidateModel="v$.modelValue"
)
  UiMultiselect(
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :options="options"
    label="text"
    :canDeselect="false"
    :canClear="false"
    :error="v$.modelValue.$error"
  )
</template>

<script>
import { defineComponent } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default defineComponent({
  emits: ["update:modelValue"],

  props: {
    label: {
      type: String,
    },
    modelValue: {
      default: null,
    },
    options: {
      type: Array,
    },
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      modelValue: {
        required,
      },
    };
  },
});
</script>
